module.exports = __webpack_public_path__ + "static/media/Vista_actividades.f0daaf2c.png";